'use client';

import { c as _c } from "react/compiler-runtime";
import { useRect } from 'hamo';
import { useLenis } from 'lenis/react';
import { useEffect, useRef, useState } from 'react';
import { mapRange } from '~/libs/maths';
import s from './scrollbar.module.css';
export function Scrollbar() {
  const $ = _c(17);
  const thumbRef = useRef(null);
  const lenis = useLenis();
  const [innerMeasureRef, innerRect] = useRect();
  const [thumbMeasureRef, thumbRect] = useRect();
  const [lenisState, setLenisState] = useState("stopped");
  const innerHeight = innerRect?.height ?? 0;
  const thumbHeight = thumbRect?.height ?? 0;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
          setLenisState(mutation.target?.classList.contains("lenis-stopped") ? "stopped" : "started");
        }
      });
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["class"]
      });
      return () => observer.disconnect();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== innerHeight || $[3] !== thumbHeight) {
    t2 = t4 => {
      const {
        scroll,
        limit
      } = t4;
      const progress = scroll / limit;
      thumbRef.current.style.transform = `translate3d(0,${progress * (innerHeight - thumbHeight)}px,0)`;
    };
    t3 = [innerHeight, thumbHeight];
    $[2] = innerHeight;
    $[3] = thumbHeight;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useLenis(t2, t3);
  let t4;
  let t5;
  if ($[6] !== innerHeight || $[7] !== lenis || $[8] !== thumbHeight) {
    t4 = () => {
      let start = null;
      const onPointerMove = function onPointerMove(e) {
        if (!(start && lenis)) {
          return;
        }
        e.preventDefault();
        const scroll_0 = mapRange(start, innerHeight - (thumbHeight - start), e.clientY, 0, lenis.limit);
        lenis.scrollTo(scroll_0, {
          immediate: true
        });
      };
      const onPointerDown = function onPointerDown(e_0) {
        start = e_0.offsetY;
      };
      const onPointerUp = function onPointerUp() {
        start = null;
      };
      thumbRef.current?.addEventListener("pointerdown", onPointerDown, false);
      window.addEventListener("pointermove", onPointerMove, false);
      window.addEventListener("pointerup", onPointerUp, false);
      return () => {
        thumbRef.current?.removeEventListener("pointerdown", onPointerDown, false);
        window.removeEventListener("pointermove", onPointerMove, false);
        window.removeEventListener("pointerup", onPointerUp, false);
      };
    };
    t5 = [lenis, innerHeight, thumbHeight];
    $[6] = innerHeight;
    $[7] = lenis;
    $[8] = thumbHeight;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== thumbMeasureRef) {
    t6 = <div className={s.thumb} ref={node => {
      if (!node) {
        return;
      }
      thumbRef.current = node;
      thumbMeasureRef(node);
    }} />;
    $[11] = thumbMeasureRef;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== innerMeasureRef || $[14] !== lenisState || $[15] !== t6) {
    t7 = <div className={s.scrollbar}><div ref={innerMeasureRef} className={s.inner} data-lenis={lenisState}>{t6}</div></div>;
    $[13] = innerMeasureRef;
    $[14] = lenisState;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}